(function () {
  var roots = document.querySelectorAll('.eco-home-hero');
  roots.forEach(function (root) {
    var videos = root.querySelectorAll('[data-eco-home-hero-video]');
    var loaded = false;
    videos.forEach(function (v) {
      var onReady = function () {
        if (loaded) return;
        loaded = true;
        root.classList.add('is-loaded');
      };
      v.addEventListener('canplaythrough', onReady, { once: true });
      // safety: mark loaded even if the browser blocks canplaythrough
      setTimeout(onReady, 2500);
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    });
  });
})();
